import { RBO_SUPPORTED_FORMATS, type RboSupportedFormat } from '@openx/types/deal';
import type { RequiredTargetingFormType } from '@openx/types/targeting/targetingPresets';

export const isTargetingRboCompatible = (format: string, hasTvDevices: boolean): boolean => {
  const formattedFormat = format?.toLowerCase();

  if (!RBO_SUPPORTED_FORMATS.includes(formattedFormat as RboSupportedFormat)) return false;
  if (formattedFormat === 'video' && hasTvDevices) return false;

  return true;
};

export const isInventoryFormatIncompatibleWithRbo = (
  inventoryFormat: RequiredTargetingFormType | null | undefined,
  options: {
    missingInventoryFormatIncompatible?: boolean;
    missingAdPlacementIncompatible?: boolean;
  } = {}
): boolean => {
  if (!inventoryFormat) {
    return options.missingInventoryFormatIncompatible ?? false;
  }

  const format = inventoryFormat?.ad_placement?.val ?? null;
  const hasTvDevices = !!inventoryFormat?.device_type?.tv_devices;

  if (!format) {
    return options.missingAdPlacementIncompatible ?? false;
  }

  return !isTargetingRboCompatible(format, hasTvDevices);
};
